import { Field, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import React from 'react';
import { Box } from '@mui/material';
import { AutoCompleteSelectUI, CheckboxUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';
import { getNextVisOrder } from './itemCategoryUtils';

const ItemCategoryFields = ({ viewField, autoCompleteOptions, selectedValues, treeData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Név" />}
          size="small"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          type="autocomplete"
          name="parentId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Szülő kategória" />}
          size="small"
          variant="outlined"
          helperText={<FormErrorUI message={errors.parentId} />}
          onChange={(_e, newVal) => {
            const parentId = newVal?.value ?? null;
            const nextVisOrder = getNextVisOrder(treeData, parentId);

            setFieldValue('parentId', parentId).then(() => {
              validateField('parentId');
            });

            setFieldValue('visOrder', nextVisOrder);
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.parentId !== '' }}
          selectedValue={values.parentId}
          selectedLabelValue={selectedValues?.parent?.name}
          dataset={autoCompleteOptions.parentCategory}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Field
          type="text"
          name="externalCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Külső azonosító" />}
          size="small"
          helperText={<FormErrorUI message={errors.externalCode} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.externalCode && values.externalCode !== '' }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Field
          type="number"
          name="visOrder"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megjelenési sorrend" />}
          size="small"
          helperText={<FormErrorUI message={errors.visOrder} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.visOrder && values.visOrder !== '' }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          variant="standard"
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </Grid>
    </Grid>
  );
};

export default ItemCategoryFields;
